import { render, staticRenderFns } from "./selfPick.vue?vue&type=template&id=496ac4f4&scoped=true&"
import script from "./selfPick.vue?vue&type=script&lang=js&"
export * from "./selfPick.vue?vue&type=script&lang=js&"
import style0 from "./selfPick.vue?vue&type=style&index=0&id=496ac4f4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496ac4f4",
  null
  
)

export default component.exports